// React
import React from 'react';
// External
import { Button, Col, Form } from 'react-bootstrap';
import { RiDeleteBinLine } from 'react-icons/ri';
import { FiPlusSquare } from 'react-icons/fi';
// Styles
import './styles.scss';

/**
 * @param {string} props.data - The text to be display in the previous button
 * @todo Change select input to customise the select options (Style)
 */
class SpecialInstructions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            instructions: props.specialInstructions && props.specialInstructions.length > 0
            ? props.specialInstructions.map((item) => ({ 
                name: item.description, 
                id: item.id
            }))
            : [''],
            errors: []
        };
    }

    handleInputChange(event, instruction) {
        const instructionIndex = event.target.id;
        const { value } = event.target;
        // Updates the state
        this.setState((prevState) => {
            const { instructions } = prevState;
            if (instructions.length - 1 < instructionIndex) {
                instructions.push({ name: value, id: instruction.id });
            } else {
                instructions[instructionIndex] = { name: value, id: instruction.id };
            }
            if (prevState.errors.length) {
                const { errors } = prevState;
                const errorIndex = errors.indexOf(instructionIndex);
                if (errorIndex >= 0) {
                    errors.splice(errorIndex, 1);
                }
                return { instructions, errors };
            }
            return { instructions };
        });
    }

    /**
     * Function call from the parent component
     */
    async handleSubmit() {
        let errors = [];
        await this.setState((prevState) => {
            errors = [];
            prevState.instructions.forEach((instruction, index) => {
             
                if (!instruction) {
                    errors.push(index);
                }
            });
            return { errors };
        });
        // Returns the data if the form has no errors
        return errors.length > 0 ? null : this.state.instructions;
    }

    hasError(indexError) {
        return this.state.errors.find((error) => error === indexError);
    }

    addInstruction() {
        this.setState((prevState) => {
            // clear errors
            this.setState({ errors: [] });

            const { instructions } = prevState;
            // Push and empty value to be updated when the user writes in the input field
            instructions.push('');
            return { instructions };
        });
    }

    removeInstruction(instructionIndex) {
        // clear errors
        this.setState({ errors: [] });

        this.setState((prevState) => {
            const { instructions } = prevState;
            // remove the item in the index clicked
            instructions.splice(instructionIndex, 1);
            return { instructions };
        });
    }

    render() {
        return (
            <div className={`instructions-container ${this.props.className ? this.props.className : ''}`}>
                <h5 className="form-header">Special instructions</h5>
                <h6>ONE INSTRUCTION PER ROW</h6>
                <Form className="pet-custom-inline-form" onSubmit={e => {e.preventDefault()}}>
                    {this.state.instructions.map((instruction, index) => (
                        <Form.Row key={index}>
                            <Form.Group as={Col} controlId={index} className="control-group">
                                <Form.Control
                                    className={
                                        this.hasError(index) || this.hasError(index) === 0
                                            ? 'form-control is-invalid'
                                            : 'form-control'
                                    }
                                    name="instruction"
                                    value={instruction.name}
                                    onChange={(event) => this.handleInputChange(event, instruction)}
                                    type="text"
                                    disabled={this.props.ownerPetDetailsDisabled}
                                />
                            </Form.Group>
                            <Form.Group as={Col} controlId={`remove-${index}`} className="control-group">
                                {!this.props.ownerPetDetailsDisabled &&
                                    <Button
                                        className="btn-delete-icon"
                                        variant="light"
                                        onClick={() => this.removeInstruction(index)}
                                    >
                                        <RiDeleteBinLine />
                                        <span>Delete row</span>
                                    </Button>
                                }
                            </Form.Group>
                        </Form.Row>
                    ))}
                    <Form.Row>
                        <Form.Group as={Col} controlId="add-row" className="control-group">
                            {!this.props.ownerPetDetailsDisabled &&
                                <Button
                                    className="btn-add-icon"
                                    variant="light"
                                    onClick={(event) => this.addInstruction(event)}
                                >
                                    <FiPlusSquare />
                                    <span>Add row</span>
                                </Button>
                            }
                        </Form.Group>
                    </Form.Row>
                </Form>
            </div>
        );
    }
}

export default SpecialInstructions;
